import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview", "form", "blueprintId", "submit"]
  static values = { reservationId: Number }

  connect() {
    this.slim = new SlimSelect({
      select: this.selectTarget,
      placeholder: "Search agreement template…",
      onChange: (info) => this.selectTemplate(info)
    })
  }

  selectTemplate(info) {
    const blueprintId = info.value || info[0]?.value
    if (!blueprintId) return

    // Set hidden input so the form submits correctly
    this.blueprintIdTarget.value = blueprintId
    this.submitTarget.disabled = false

    // Fetch preview
    fetch(this.previewUrl(blueprintId))
      .then(r => r.json())
      .then(data => {
        this.previewTarget.classList.remove("d-none")
        this.previewTarget.querySelector(".agreement-preview").innerHTML = data.html
      })
  }

  previewUrl(blueprintId) {
    return `/admin_portal/reservations/${this.reservationIdValue}/preview_agreement?blueprint_id=${blueprintId}`
  }

  disconnect() {
    if (this.slim) this.slim.destroy()
  }
}
